import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy, ElementRef, ViewChild } from "@angular/core";
import * as _ from "lodash";
import Utils from "../../shared/utils";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { ProductDetailsDataModel3, ProductExtraDataModel3, RecipelinkingViewModel, ProductViewModel, BaseUnit } from "../../shared/models";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { ItemTagType, TranslationContentType, YourAPPProductType } from "../../shared/contentTypes";
import { CoreLogService } from "../../services/log.service";
import { ProductDetailsHelperService } from "../../services/product_details_helper.service";
import { WebShopService } from "../../services/webShop.service";
import { ProductConfigurationExtra } from "../../services/IWebShopService";
import { Router } from "@angular/router";
import { DepositView } from "../../shared/models/webshop.model";
import { ProductService } from "../../services/product.service";
import { Subscription } from "rxjs";
import { ItemTagHelperService } from "../../services/itemTagHelper.service";
import { IProductViewModel } from "../../shared/models/product.facade";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLanguageManager } from "../../services/ILanguageManager";
import { environment } from "../../../../environments/environment";

export interface ArticleCardOptions {
  checkAvailability?: boolean; // true;
  showPrice?: boolean; // true;
  allowAddingToBasket?: boolean; // true;
  allowViewingDetails?: boolean; // true;
  useECommerce?: boolean;//false
}

// TODO Add Discount Pricing
@Component({
  selector: "ya-articlecard",
  templateUrl: "./articleCard.component.html",
  styleUrls: ["./articleCard.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() product: IProductViewModel;
  @Input() options: ArticleCardOptions = {};
  @Input() isItemTagEnabled: boolean = false; // todo move isItemTagEnabled to ArticleCardOptions
  @Input() itemTagType: ItemTagType = ItemTagType.Text; // todo move itemTagType to ArticleCardOptions
  /** item group in die navigiert wird, wenn Artikel bestellt oder zurueck navigiert */
  @Input() returnItemGroupId: number = -1;
  /** Fires with the resolved product id right before navigating to menudetail/recipeLink; no-op for consumers that don't listen. */
  @Output() beforeNavigate = new EventEmitter<number>();
  /** Fires with the resolved product id when the navigation started by beforeNavigate did not succeed, so a caller can undo work it did in response to beforeNavigate. */
  @Output() navigationFailed = new EventEmitter<number>();

  @ViewChild("descriptionDiv") private descriptionDiv: ElementRef;
  @ViewChild("descriptionTextDiv") private descriptionTextDiv: ElementRef;

  private _productDetails: ProductDetailsDataModel3;
  public tagType = ItemTagType;
  public activeEllipse: boolean = false;

  public imagePhoto: string;

  public get hasTag(): boolean {
    return this.isItemTagEnabled && this.product.itemTags && this.product.itemTags.length > 0;
  }

  public description_de: string;
  public description_en: string;
  public get description(): string {
    const _description = InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.description_en) ? this.description_de : this.description_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_Details, this.product.id, _description);
    }
    return _description
  }
  public standartPrice: number;
  public finalPrice: number;
  public deposit: number;
  public hasBaseUnit: boolean = false;
  public prepackaged: boolean;

  /** The article count is more than the minimum and is not blacklisted */
  public isAvailable: boolean = true;
  public includeDeposit: boolean = true;
  private _discount: number;
  private _shippingCartSubscription: Subscription;

  public _options: ArticleCardOptions;
  private _defaultOptions: ArticleCardOptions = {
    checkAvailability: true,
    showPrice: true,
    allowAddingToBasket: true,
    allowViewingDetails: true,
    useECommerce: false
  }

  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _objObsInjectHelper: CircularInjectionHelper,
    private _productService: ProductService,
    private _itemTagHelperService: ItemTagHelperService,
    private _webShopService: WebShopService,
    private _router: Router,
    private _coreLanguageService: CoreLanguageService) {
    const me = this;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._shippingCartSubscription) {
      me._shippingCartSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ArticleCard.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._options = _.merge({}, me._defaultOptions, me.options);
    me._shippingCartSubscription = me._webShopService.ShippingCartObserver.subscribe(async () => {
      await me.setProductInformations();
      // setProductInformations ist async und kann länger dauern, so das die Componente bereits destroyt wurde
      if (me._shippingCartSubscription) {
        me.PushChanges();
      }
    });
    me._webShopService.getWebshopSettingsDataModel().then((settings) => {
      me.includeDeposit = settings.deposit_view === DepositView.AddInArticlelist;
      me.PushChanges();
    });
    me.getProductECommerceInfo().then(() => {
      if (!me._changeDetectorRef['destroyed']) {
        me.PushChanges();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // const me = this;
    // if (changes["options"]) {
    //   me._options = _.merge({}, me._defaultOptions, me.options);
    // }
    // if (changes["productId"]) {
    //   me.setProductInformations();
    //   me.PushChanges();
    // }
  }

  private async getProductDetailDataModel(): Promise<ProductDetailsDataModel3> {
    const me = this;
    if (me.product.is_recipe_linking) {
      me._coreLogService.error("ArticleCardComponent.getProductDetailDataModel", "RecipeLinking cand get Details");
      throw new Error("RecipeLinking cand get Details");
    }

    if (me._productDetails) {
      return me._productDetails;
    } else {
      try {
        const product_view = <ProductViewModel>me.product;
        me._productDetails = await ProductDetailsHelperService.GetProductDetails(product_view.model, me._objObsInjectHelper, true, false);
        return me._productDetails;
      } catch (e) {
        me._coreLogService.error("ArticleCardComponent.getProductDetailDataModel", "ProductDetailsHelperService.GetProductDetails (could not find matching ProductDetails)", e);
      }
    }
  }


  private async setProductInformations(): Promise<void> {
    const me = this;
    //product oder recipe link laden
    try {
      if (me._options.checkAvailability) {
        if (me.product.is_recipe_linking) {
          me.isAvailable = false;
          const recipelinking_view = <RecipelinkingViewModel>me.product;
          for (let index = 0; index < recipelinking_view.products.length; index++) {
            const product_view = recipelinking_view.products[index];
            me.isAvailable = await me._webShopService.isProductAvailable$(product_view.product_id);
            if (me.isAvailable) {
              break; // ein Artikel ist verfügbar dann auch die Rezepturverkettung
            }
          }
        } else {
          me.isAvailable = await me._webShopService.isProductAvailable$(me.product.product_id);
        }
      } else {
        me.isAvailable = true;
      }
      if (me.product.is_recipe_linking) {
        const recipelinking_view = <RecipelinkingViewModel>me.product;
        for (let index = 0; index < recipelinking_view.products.length; index++) {
          const product_view = recipelinking_view.products[index];
          const prices = await me._webShopService.getProductPrices(product_view.model, false);
          if (Utils.IsNull(me.finalPrice) || prices.discountPriceWithExtras < me.finalPrice) {
            me.standartPrice = prices.priceWithExtras;
            me.finalPrice = prices.discountPriceWithExtras;
            me.deposit = prices.depositWithExtras;
          }
        }
      } else {
        const product_view = <ProductViewModel>me.product;
        const prices = await me._webShopService.getProductPrices(product_view.model, false);
        me.standartPrice = prices.priceWithExtras;
        me.finalPrice = prices.discountPriceWithExtras;
        me.deposit = prices.depositWithExtras;
      }

      me._discount = me._webShopService.discountPercent;
      if (me.product.hasImage) {
        me.imagePhoto = me.product.imageUrl;
      } else {
        await me.switchToTextLayout();
      }
    } catch (e) {
      me._coreLogService.error("ArticleCardComponent.setProductInformations", "_productObsServ.GetObject (could not find matching Product)", e);
    }
  }

  private async switchToTextLayout() {
    const me = this;
    me.imagePhoto = "";
    try {
      if (me.product.is_recipe_linking) {
        const recipelinking_view = <RecipelinkingViewModel>me.product;
        me.description_de = Utils.decodeHTMLEntities(recipelinking_view.details_de);
        me.description_en = Utils.decodeHTMLEntities(recipelinking_view.details_en);
      } else {
        const detailModel = await me.getProductDetailDataModel();
        me.description_de = Utils.decodeHTMLEntities(detailModel.details_de);
        me.description_en = Utils.decodeHTMLEntities(detailModel.details_en);
      }
      me.PushChanges();
      setTimeout(() => {
        if (me.descriptionDiv && me.descriptionTextDiv) {
          const descriptionHeight = (me.descriptionDiv.nativeElement as HTMLElement).clientHeight;
          const descriptionTextHeight = (me.descriptionTextDiv.nativeElement as HTMLElement).clientHeight;
          if (descriptionHeight < descriptionTextHeight) {
            me.activeEllipse = true;
            me.PushChanges();
          }
        }
      }, 200);
    } catch (e) {
      me._coreLogService.error("ArticleCardComponent.switchToTextLayout", "getProductDetailDataModel", e);
    }
  }

  public svgSanitizer(svg: string, color: string) {
    const me = this;
    return me._itemTagHelperService.svgSanitizer(svg, color);
  }

  public get useECommerce() {
    const me = this;
    return me._options.useECommerce;
  }

  private async getProductECommerceInfo(): Promise<void> {
    const me = this;
    try {
      if (!me.product.is_recipe_linking) {
        const productDetail = await me.getProductDetailDataModel();
        if (productDetail) {
          me._item_baseFactor = productDetail.item_base_factor;
          me._item_caffeine = productDetail.item_caffeine;
          me._item_alcoholLevel = productDetail.item_alcohol;
          me._item_base_unit = productDetail.item_base_unit_id;
          if (me._item_base_unit !== BaseUnit.NONE) {
            me.hasBaseUnit = me._item_base_unit !== BaseUnit.NONE
          }
          me.prepackaged = productDetail.prepackaged;
        }
      }
    } catch (e) {
      me._coreLogService.error("ArticleCardComponent.getProductECommerceInfo", e.message, e);
    }
  }


  //E-Commerce information
  private _item_baseFactor: number;
  /** Product price per unit */
  public get pricePerUnit(): string {
    const me = this;
    const currentPrice = Utils.IsNull(me.finalPrice) ? 0 : me.finalPrice;
    const pricePerUnit = Utils.pricePerUnit(currentPrice, me._item_baseFactor);
    return me.priceFormatter(pricePerUnit);
  }

  private _item_caffeine: number;
  public get hasCaffeineLevel(): boolean {
    const me = this;
    return me._item_caffeine > 0;
  }

  /** Caffeine content */
  public get CaffeinelevelText(): string {
    const me = this;
    return me._coreLanguageService.value("phProductDetail_Caffeine_Content")
      .replace("{value}", me._item_caffeine.toString()) + " mg";
  }

  private _item_alcoholLevel: number;
  public get hasAlcoholLevel() {
    const me = this;
    return me._item_alcoholLevel > 0;
  }

  /** Alcohol content */
  public get AlcohollevelText(): string {
    const me = this;
    return me._coreLanguageService.value("phProductDetail_Alcohol_Content")
      .replace("{value}", me._item_alcoholLevel.toString()) + " % Vol.";
  }

  private _item_base_unit: number;

  public get baseUnit(): string {
    const me = this;
    switch (me._item_base_unit) {
      case BaseUnit.PIECE:
        return me.pricePerUnit + " / 1" + (InternationalisationService.locale === "de" ? "Stk" : "pc");
      case BaseUnit.LITER:
        return me.pricePerUnit + " / 1l";
      case BaseUnit.KILO:
        return me.pricePerUnit + " / 1kg";
      case BaseUnit.NONE:
        return "";
      default:
        me._coreLogService.error("ArticleCardComponent.baseUnit", "unknown item_base_unit", me._item_base_unit);
        return "";
    }
  }

  // format price base on language
  public priceFormatter(price: number): string {
    const me = this;
    return _.isNil(price) ? "" : me._webShopService.formatCurrency(price);
  }

  public async viewDetails(): Promise<void> {
    const me = this;
    if (me._options.allowViewingDetails) {
      /** allow navigation to menu detail if product is isAvailable && availible */
      if (me.isAvailable && me.product.availible) {
        me.beforeNavigate.emit(me.product.id);
        let success = false;
        try {
          if (me.product.is_recipe_linking) {
            success = await me._router.navigate(["recipeLink", me.returnItemGroupId, me.product.id, me.product.location]);
          } else {
            success = await me._router.navigate(["menudetail", me.returnItemGroupId, me.product.id, me.product.location]);
          }
        } catch (error) {
          me._coreLogService.error("ArticleCardComponent.viewDetails", "router.navigate", error);
        }
        if (!success) {
          me.navigationFailed.emit(me.product.id);
        }
      }
    }
  }

  public getDisplayedStandartPrice() {
    return this.includeDeposit ? (this.standartPrice + this.deposit) : this.standartPrice;
  }

  public getDisplayedFinalPrice() {
    return this.includeDeposit ? (this.finalPrice + this.deposit) : this.finalPrice;
  }

  public onImageError() {
    this.switchToTextLayout();
  }
}
